'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactNotificationsHub = require('@cimpress-technology/react-notifications-hub');

var _reactComponents = require('@cimpress/react-components');

var _reactI18next = require('react-i18next');

var _i18n = require('../../tools/i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubscribeButton = function (_React$Component) {
    _inherits(SubscribeButton, _React$Component);

    function SubscribeButton(props) {
        _classCallCheck(this, SubscribeButton);

        var _this = _possibleConstructorReturn(this, (SubscribeButton.__proto__ || Object.getPrototypeOf(SubscribeButton)).call(this, props));

        _this.state = {
            showSelectorModal: false
        };
        _this.onClick = _this.onClick.bind(_this);
        _this.onClose = _this.onClose.bind(_this);
        return _this;
    }

    _createClass(SubscribeButton, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Show the selector modal by default if the user has just completed the auth flow.
            if (this.props.returningFromAuth) {
                this.setState({ showSelectorModal: true });
            }
        }
    }, {
        key: 'onClick',
        value: function onClick() {
            var _this2 = this;

            try {
                this.props.ensureAuthorized().then(function (res) {
                    if (res.isAuthorized) {
                        _this2.setState({ showSelectorModal: true });
                    }
                });
            } catch (error) {
                // if they hit cancel, promise is rejected and we do nothing
            }
        }
    }, {
        key: 'onClose',
        value: function onClose() {
            this.setState({ showSelectorModal: false });
        }
    }, {
        key: 'tt',
        value: function tt(key) {
            // eslint-disable-next-line react/prop-types
            var _props = this.props,
                t = _props.t,
                locale = _props.locale;

            if (locale.length > 2) {
                locale = locale.substr(0, 2);
            }
            return t(key, { lng: locale });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                SubscriptionSelector = _props2.SubscriptionSelector,
                accessToken = _props2.accessToken,
                environment = _props2.environment,
                commentUri = _props2.commentUri;
            var showSelectorModal = this.state.showSelectorModal;


            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    _reactComponents.Button,
                    { type: 'link', style: { padding: '10px' }, onClick: this.onClick },
                    this.props.textOverrides.subscribeButtonLabel || this.tt('subscribeOrUnsubscribe')
                ),
                _react2.default.createElement(SubscriptionSelector, {
                    show: showSelectorModal,
                    onClose: this.onClose,
                    accessToken: accessToken,
                    environment: environment,
                    commentUri: commentUri,
                    unsubscriptionModalMessage: this.props.textOverrides.unsubscriptionModalMessage,
                    subscriptionModalMessage: this.props.textOverrides.subscriptionModalMessage,
                    modalTitle: this.props.textOverrides.modalTitle
                })
            );
        }
    }]);

    return SubscribeButton;
}(_react2.default.Component);

SubscribeButton.propTypes = {
    ensureAuthorized: _propTypes2.default.func.isRequired,
    returningFromAuth: _propTypes2.default.bool,
    SubscriptionSelector: _propTypes2.default.func,
    subscriptionSelectorProps: _propTypes2.default.object,
    accessToken: _propTypes2.default.string,
    environment: _propTypes2.default.string,
    textOverrides: _propTypes2.default.shape({
        modalTitle: _propTypes2.default.string,
        unsubscriptionModalMessage: _propTypes2.default.string,
        subscriptionModalMessage: _propTypes2.default.string,
        subscribeButtonLabel: _propTypes2.default.string
    }),
    locale: _propTypes2.default.string,
    commentUri: _propTypes2.default.string
};

SubscribeButton.defaultProps = {
    locale: 'en'
};

exports.default = (0, _reactI18next.translate)('translations', { i18n: (0, _i18n.getI18nInstance)() })((0, _reactNotificationsHub.withNotificationsHubAuthFlow)(SubscribeButton));